import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import line from "../Assests/line.png";
import cycle from "../Assests/cycle.png";
import run from "../Assests/run.png";
import cloth from "../Assests/cloth.png";
import led from "../Assests/led.png";
import "./VisitEvent.css";

const VisitEvent = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const leftColumnItems = [
    {
      image: cycle,
      bgColor: "#F56A02",
      text: t("Program_About4"),
      imageAlt: "cycle"
    },
    {
      image: run,
      bgColor: "#207FB7",
      text: t("about13"),
      imageAlt: "run"
    }
  ];

  const rightColumnItems = [
    {
      bgColor: "#08B749",
      text: t("About2"),
      hasImageAfter: true,
      imageAfter: cloth,
      imageAltAfter: "cloth"
    },
    {
      bgColor: "#FFA800",
      text: t("Educational_Awareness_Program_About"),
      textColor: "black",
      hasImageAfter: true,
      imageAfter: led,
      imageAltAfter: "led"
    }
  ];

  const mobileItems = [
    { image: cycle, bgColor: "#08B749", text: t("About2") },
    { image: cloth, bgColor: "#F56A02", text: "महिलाओ को आत्मनिर्भर बनाने हेतु सिलाई मशीन का वितरण, ग्रामीण महिलाओं को आत्मनिर्भर बनाने हेतु आर्थिक सहायता राशि एवं ग्रामीण बहन-बेटियों को विवाहोत्सव पर आत्मनिर्भर एवं सशक्त बनने हेतु जरुरत स्वरूप सामग्री भेंट ।" },
    { image: run, bgColor: "#FFA800", text: t("Educational_Awareness_Program_About"), textColor: "black" },
    { image: led, bgColor: "#207FB7", text: t("about13") }
  ];

  return (
    <div className="visit-event-wrapper">
      <Container>
        <div className={`event-header ${isVisible ? 'fade-in' : ''}`}>
          <h2 className="event-title">{t("heading_new3")}</h2>
          <div className="event-line">
            <img src={line} alt="line" />
          </div>
        </div>

        {/* Desktop View */}
        <div className="desktop-view">
          <Row className="event-row">
            <Col lg={6}>
              {leftColumnItems.map((item, idx) => (
                <div key={idx} className="event-block">
                  <div className="event-image">
                    <img src={item.image} alt={item.imageAlt} />
                  </div>
                  <div className="event-text" style={{ backgroundColor: item.bgColor }}>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </Col>

            <Col lg={6}>
              {rightColumnItems.map((item, idx) => (
                <div key={idx} className="event-block">
                  <div className="event-text" style={{ 
                    backgroundColor: item.bgColor,
                    color: item.textColor || "white"
                  }}>
                    <p>{item.text}</p>
                  </div>
                  {item.hasImageAfter && (
                    <div className="event-image">
                      <img src={item.imageAfter} alt={item.imageAltAfter} />
                    </div>
                  )}
                </div>
              ))}
            </Col>
          </Row>
        </div>

        {/* Mobile View */}
        <div className="mobile-view">
          {mobileItems.map((item, idx) => (
            <div key={idx} className="mobile-event-block">
              <div className="mobile-event-image">
                <img src={item.image} alt="event" />
              </div>
              <div className="mobile-event-text" style={{ 
                backgroundColor: item.bgColor,
                color: item.textColor || "white"
              }}>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default VisitEvent;